/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SizeLabel {
    S = 0,
    M = 1,
    L = 2,
    XL = 3,
    XXL = 4,
    XL3 = 5,
    XL4 = 6,
    XL5 = 7,
    XL6 = 8,
    XL7 = 9,
    XL8 = 10,
    XL9 = 11,
    XL10 = 12,
    XL11 = 13,
    XL12 = 14,
    XL13 = 15,
    XL14 = 16,
    XL15 = 17,
}
